import { decodeHexResponse } from '../_common/common.utils';
import EmployeeListActionTypes from './employeelist.types';

const INITIAL_STATE = {
	allEmployeeListData: null,
	employeeDetailsBasedOnIDResponce: null,
	employeeDetailsBasedOnIDArray: [],
	updateEmployeeResponse: null,
	error: null,
};

const employeeListReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	switch (action.type) {
		case EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_START:
			return { ...state, allEmployeeListData: null };
		case EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_SUCCESS:
			return {
				...state,
				allEmployeeListData: decodeHexResponse(
					action.payload,
					EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_KEY,
				),
			};
		case EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_FAILURE:
			return {
				...state,
				error: decodeHexResponse(
					action.payload,
					EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_KEY,
				),
				allEmployeeListData: null,
			};
		case EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_RESPONSE_CHANGED:
			return { ...state, allEmployeeListData: action.payload };
		case EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_START:
			return state; // Don't reset the data
		case EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_SUCCESS:
			return {
				...state,
				allEmployeeListData: decodeHexResponse(
					action.payload,
					EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_KEY,
				),
			};
		case EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_FAILURE:
			return { ...state, allEmployeeListData: null };

		// case EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_START:
		// 	return { ...state, employeeDetailsBasedOnID: null };
		case EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_SUCCESS:
			return {
				...state,
				employeeDetailsBasedOnIDResponce: action.payload,
				employeeDetailsBasedOnIDArray: decodeHexResponse(
					action.payload,
					'fetchEmployeeDetailsBasedOnIDKey',
				),
			};
		case EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_FAILURE:
			return {
				...state,
				employeeDetailsBasedOnIDResponce: null,
				employeeDetailsBasedOnIDArray: [],
			};
		case EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_RESPONSE_CHANGED:
			return {
				...state,
				employeeDetailsBasedOnIDResponce: null,
				employeeDetailsBasedOnIDArray: action.payload,
			};
		// case EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_RESPONSE_REST_START:
		// 	return { ...state, employeeDetailsBasedOnID: null };
		// case EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_RESPONSE_REST_SUCCESS:
		// 	return { ...state, employeeDetailsBasedOnID: action.payload };
		// case EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_RESPONSE_REST_FAILURE:
		// 	return { ...state, employeeDetailsBasedOnID: null };
		case EmployeeListActionTypes.UPDATE_EMPLOYEE_START:
			return { ...state, updateEmployeeResponse: null };
		case EmployeeListActionTypes.UPDATE_EMPLOYEE_SUCCESS:
			return {
				...state,
				updateEmployeeResponse: decodeHexResponse(
					action.payload,
					'updateEmployeeDetailsKey',
				),
			};
		case EmployeeListActionTypes.UPDATE_EMPLOYEE_FAILURE:
			return {
				...state,
				error: decodeHexResponse(action.payload, 'updateEmployeeDetailsKey'),
				updateEmployeeResponse: null,
			};
		case EmployeeListActionTypes.UPDATE_EMPLOYEE_RESPONSE_REST_START:
			return { ...state, updateEmployeeResponse: null };
		default:
			return state;
	}
};

export default employeeListReducer;
